'use client';

import { useSyncExternalStore } from 'react';
import { getStoredWorkspaceId, subscribeStoredWorkspaceId } from '@/shared/utils/workspace';

const getServerWorkspaceId = (): null => null;

export const useStoredWorkspaceId = (): string | null =>
  useSyncExternalStore(subscribeStoredWorkspaceId, getStoredWorkspaceId, getServerWorkspaceId);
